import React, { useState } from 'react';
import { StoreHeader } from '../components/store/StoreHeader';
import { StoreItemCard } from '../components/store/StoreItemCard';
import { storeItems } from '../data/storeItems';
import { StyledButton } from '../components/ui/StyledButton';

export const StorePage = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleBuyItem = (item) => {
    // TODO: Implement purchase flow with blockchain transaction
    alert(`Purchase ${item.name} for ${item.price} CHI tokens?\n\nThis feature is coming soon!`);
  };

  const filteredItems = storeItems.filter(item =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.description.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-bg overflow-y">
      <StoreHeader />

      <main className="container mx-auto px-6 py-8 pb-24">
        {/* Search Bar */}
        <div className="mb-8">
          <input
            type="text"
            placeholder="搜索项目 Search items..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full max-w-md px-4 py-3 rounded-base border-2 border-border shadow-light focus:outline-none focus:translate-x-boxShadowX focus:translate-y-boxShadowY focus:shadow-none transition-all font-base"
          />
        </div>

        {/* Store Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8">
          {filteredItems.map((item) => (
            <StoreItemCard
              key={item.id}
              item={item}
              onBuy={handleBuyItem}
            />
          ))}
        </div>

        {/* No Results */}
        {filteredItems.length === 0 && (
          <div className="text-center py-16">
            <p className="text-2xl font-heading text-text/50">No items found</p>
            <p className="text-sm text-text/40 mt-2">Try a different search term</p>
          </div>
        )}

        {/* Footer Info */}
        <div className="mt-8 p-6 bg-white rounded-base border-2 border-border shadow-light">
          <h3 className="text-xl font-heading mb-2">关于 $CHI 代币 (About $CHI Tokens)</h3>
          <p className="text-sm text-text/70">
            $CHI 代币是 币安歌子 Binagotchi 的高级货币。购买道具，提升游戏体验！所有交易均在区块链上安全保障。
            <br/>
            CHI tokens are the premium currency for Binagotchi. Purchase items to enhance your gameplay experience!
            All transactions are secured on the blockchain.
          </p>
        </div>
        <div className="">

        </div>
      </main>
    </div>
  );
};

export default StorePage;
